import React from 'react'
import { Box, Typography, Paper } from '@mui/material'
import { styled } from '@mui/material/styles'
import { LinearBarChart } from 'components/Common/LinearBarChart'
import PayablePaidTable from './Tables/PayablePaidTable'
import PayableUnpaidTable from './Tables/PayableUnpaidTable'

const StyledPaper = styled(Paper)(({ theme }) => ({
  width: '40%',
  height: '100%',
  boxShadow: '4px 4px 15px grey',
  borderRadius: '10px',
}))

export const PayableBillTab = ({ billDetails, daySpanSelected, codatConnected }) => {
  return (
    <>
      <Typography variant="h5" color="#25245f" textAlign="center" marginBottom="20px">
        Bills
      </Typography>
      <Box display="flex" justifyContent="center" color="#66668f">
        <StyledPaper>
          <Typography variant="h6" padding="10px" textAlign="left">
            Bills
          </Typography>
          <Box padding="10px">
            <Box marginBottom="20px" display="flex" alignItems="center">
              <Typography component="span" variant="h6" marginRight="20px">
                ${billDetails.unpaidBillsAmount} Unpaid
              </Typography>
              <Typography component="span" variant="body1">
                Last {daySpanSelected} days
              </Typography>
            </Box>
            <Box justifyContent="space-between" display="flex">
              <Typography component="span" variant="h6">
                ${billDetails.unpaidBillsOverdueAmount}
              </Typography>
              <Typography component="span" variant="h6">
                ${billDetails.unpaidBillsNotDueAmount}
              </Typography>
            </Box>
            <Box justifyContent="space-between" display="flex">
              <Typography component="span" variant="body1">
                Overdue
              </Typography>
              <Typography component="span" variant="body1">
                Not due yet
              </Typography>
            </Box>
            <LinearBarChart
              values={[
                parseFloat(billDetails.unpaidBillsOverdueAmount) || 1,
                parseFloat(billDetails.unpaidBillsNotDueAmount) || 1,
              ]}
              colors1="#F48001"
              colors2="#8B4000"
            />
          </Box>
          {/* <Box padding="10px">
            <Box marginBottom="20px">
              <Typography component="span" variant="h6" marginRight="20px">
                ${billDetails.paidBillsAmount} Paid
              </Typography>
              <Typography component="span" variant="body1">
                Last {daySpanSelected} days
              </Typography>
            </Box>
            <Box justifyContent="space-between" display="flex">
              <Typography component="span" variant="h6">
                ${billDetails.paidBillsDepositedAmount}
              </Typography>
              <Typography component="span" variant="h6">
                ${billDetails.paidBillsNotDepositedAmount}
              </Typography>
            </Box>
            <Box justifyContent="space-between" display="flex">
              <Typography component="span" variant="body1">
                Not deposited
              </Typography>
              <Typography component="span" variant="body1">
                Deposited
              </Typography>
            </Box>
            <LinearBarChart
              values={[
                parseFloat(billDetails.paidBillsDepositedAmount) || 1,
                parseFloat(billDetails.paidBillsNotDepositedAmount) || 1,
              ]}
              colors1="#84D201"
              colors2="#42A001"
            />
          </Box> */}
        </StyledPaper>
      </Box>
      <Box marginTop="40px">{codatConnected && <PayableUnpaidTable />}</Box>
      <Box margin="40px 0px 40px 0px">{codatConnected && <PayablePaidTable />}</Box>
    </>
  )
}
